export default "__VITE_ASSET__CvIDO2DW__"